import * as React from 'react';
import Raven from 'raven-js';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import WalmartFilterBranchRenderer from 'flow-doctor-lib/components/filters/WalmartFilterBranchRenderer';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UISection from 'UIComponents/section/UISection';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import UILink from 'UIComponents/link/UILink';
import { getListUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListEvaluationTable = ({
  evaluationResultsByListId,
  flowRevision
}) => {
  // Non-contact flows only have a single suppression list
  if (!flowRevision.flow.isClassicWorkflow) {
    const [listId, debugBranch] = Object.entries(evaluationResultsByListId)[0];
    const maybeSuppressionList = flowRevision.flow.associatedLists.find(list => String(list.listId) === listId);
    if (!maybeSuppressionList) {
      Raven.captureMessage('Got unexpected suppression list evaluation for non-enrollment check', {
        extra: {
          debugBranch,
          listId
        }
      });
      return null;
    }
    return /*#__PURE__*/_jsx(UISection, {
      className: "m-top-3",
      children: /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
        objectTypeId: flowRevision.flow.objectTypeId,
        filterBranch: maybeSuppressionList.filterBranch,
        debugOptions: {
          filterBranch: debugBranch,
          displayMode: 'ALL'
        },
        filterWidthType: "DEFAULT"
      })
    });
  }
  return /*#__PURE__*/_jsx(UISection, {
    className: "m-top-3",
    children: Object.keys(evaluationResultsByListId).map(listId => {
      const debugBranch = evaluationResultsByListId[Number(listId)];
      const isMemberOfList = debugBranch.acceptedStatus === 'ACCEPTED';
      const maybeSuppressionList = flowRevision.flow.associatedLists.find(list => String(list.listId) === listId);
      if (!maybeSuppressionList) {
        Raven.captureMessage('Got unexpected suppression list evaluation for non-enrollment check', {
          extra: {
            debugBranch,
            listId
          }
        });
        return null;
      }
      return /*#__PURE__*/_jsx(UITile, {
        compact: true,
        children: /*#__PURE__*/_jsxs(UITileSection, {
          className: "p-y-3",
          children: [/*#__PURE__*/_jsx(UITruncateString, {
            children: /*#__PURE__*/_jsx(UILink, {
              href: getListUrl({
                portalId: flowRevision.portalId,
                listId
              }),
              external: true,
              children: /*#__PURE__*/_jsx(ListNameLabel, {
                portalId: flowRevision.portalId,
                listId: Number(listId),
                showId: getIsInternal()
              })
            })
          }), /*#__PURE__*/_jsx(UIAccordionItem, {
            className: "m-top-2",
            title: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              children: [isMemberOfList ? /*#__PURE__*/_jsx(RemoveIcon, {
                color: "do-not-use-candy-apple"
              }) : /*#__PURE__*/_jsx(SuccessIcon, {
                color: "do-not-use-oz"
              }), /*#__PURE__*/_jsx(Text, {
                marginInlineStart: "200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: isMemberOfList ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.table.content.isMember' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.SUPPRESSION_LIST_EVALUATION.table.content.notMember'
                })
              })]
            }),
            children: /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
              objectTypeId: flowRevision.flow.objectTypeId,
              filterBranch: maybeSuppressionList.filterBranch,
              debugOptions: {
                filterBranch: debugBranch,
                displayMode: 'ALL'
              },
              filterWidthType: "DEFAULT"
            })
          })]
        })
      }, listId);
    })
  });
};
export default ListEvaluationTable;